var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpDecorator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "15px",
    viewBox: "0 0 30 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0L30 15H0Z",
    fill: "#edf3ff",
    id: "arrow-bg"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0L30 15",
    stroke: "#607DCB",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0L0 15",
    stroke: "#607DCB",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDecorator);
export default __webpack_public_path__ + "static/media/arrow-up-decorator.2a41c725ba50dcfd5043cd7722b1453a.svg";
export { ForwardRef as ReactComponent };